module.exports = __webpack_public_path__ + "public/img/photoImport1.9525c5a4.svg";